<template>
  <el-button type="primary" icon="el-icon-search" @click="Search">查询</el-button>
</template>

<script>
  export default {
    name: 'SearchButton',
    props: {
      url: {
        type: String
      },
      level: {
        type: Number
      },
      hasform: {
        type: Boolean
      }
    },
    methods: {
      Search: function() {
        var parent = this.$parent
        var levelCount = this.level == null ? 0 : this.level

        for (var i = 2; i <= levelCount; i++) {
          parent = parent.$parent
        }

        console.log(parent.condition)
        if (parent.DataList != null) {
          parent.DataList()
        } else {
          if (parent.loading != null) {
            parent.loading = true
          }
          if (parent.condition.firstSearch == true) {
            parent.condition.currentPage = 1
          }
          this.$http.post(this.url, parent.condition)
            .then(res => {
              parent.condition.firstSearch = true
              if (res.data.Code === 0) {
                if (this.hasform === true) {
                  parent.form.tableData = res.data.Data
                  parent.form.condition.recordCount = res.data.Pager.RecordCount
                } else {
                  parent.tableData = res.data.Data
                  parent.condition.recordCount = res.data.Pager.RecordCount
                }
              } else {
                this.$message({
                  message: res.data.Msg + '，' + res.data.Error,
                  type: 'error'
                })
              }
              if (parent.loading != null) {
                parent.loading = false
              }
            })
            .catch(err => {
              parent.condition.firstSearch = true
              if (this.hasform === true) {
                parent.form.tableData = null
                parent.form.condition.recordCount = 0
              } else {
                parent.tableData = null
                parent.condition.recordCount = 0
              }
              console.log(err)
              this.$message({
                message: '查询失败',
                type: 'error'
              })
            })
        }
      }
    }
  }
</script>

<style>
</style>
